import { useCallback, useMemo } from "react";
import { DEMAND } from "@demandproai/shared";

const useDemandStudioPreviewSelectors = ({ previewState }) => {
  const {
    demandOptions,
    selectedDemandType,
    onSelectDemandType,
    lifecareClientOptions,
    selectedLifecareClientId,
    onSelectLifecareClient,
    docxOptions,
    selectedDocxUrl,
    onSelectDocx,
  } = previewState;

  const isLifecareSelected = selectedDemandType === DEMAND.Lifecare_Plan;
  const hasDemandSelector = demandOptions.length > 1;
  const hasClientSelector = isLifecareSelected && lifecareClientOptions.length > 1;
  const hasDocxSelector = docxOptions.length > 1;
  const shouldRender = hasDemandSelector || hasClientSelector || hasDocxSelector;

  const handleDemandTypeChange = useCallback(
    (event) => onSelectDemandType({ value: event.target.value }),
    [onSelectDemandType]
  );

  const handleDocxChange = useCallback(
    (event) => onSelectDocx({ value: event.target.value }),
    [onSelectDocx]
  );

  const demandSelector = useMemo(
    () =>
      hasDemandSelector
        ? {
            id: "demand-studio-demand-type-select",
            ariaLabel: "Select demand type",
            value: selectedDemandType,
            onChange: handleDemandTypeChange,
            options: demandOptions,
          }
        : null,
    [hasDemandSelector, selectedDemandType, handleDemandTypeChange, demandOptions]
  );

  const clientSelector = useMemo(
    () =>
      hasClientSelector
        ? {
            options: lifecareClientOptions,
            selectedClientId: selectedLifecareClientId,
            onSelectClient: onSelectLifecareClient,
            variant: "header",
          }
        : null,
    [hasClientSelector, lifecareClientOptions, selectedLifecareClientId, onSelectLifecareClient]
  );

  const docxSelector = useMemo(
    () =>
      hasDocxSelector
        ? {
            id: "demand-studio-docx-select",
            ariaLabel: "Select document",
            value: selectedDocxUrl,
            onChange: handleDocxChange,
            options: docxOptions,
          }
        : null,
    [hasDocxSelector, selectedDocxUrl, handleDocxChange, docxOptions]
  );

  return {
    shouldRender,
    demandSelector,
    clientSelector,
    docxSelector,
  };
};

export default useDemandStudioPreviewSelectors;
